import { ConcreteEncodable } from "./ConcreteEncodable";

import { StandardReportImplEncoder } from "../../encoder/StandardReportImplEncoder";

import * as CubiqTS from "../../index";
import { StandardReport } from "../StandardReport";

export class StandardReportImpl extends ConcreteEncodable implements StandardReport {
  public static enType: string = "com.bcdfx.service.StandardReportImpl";

  /*FID=1*/
  public results: Array<any> | null = null;
  /*FID=2*/
  public isLastReport: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = StandardReportImplEncoder.Instance;
    this.setEncodableType(StandardReportImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "StandardReportImpl[" +
      "results=" +
      this.results +
      "isLastReport=" +
      this.isLastReport +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
